export default function videoDialog(id: string) {
  const elem = document.querySelector(`#${id} .aspect-video`);
  const embed = elem?.firstElementChild?.outerHTML;

  return {
    open: false,
    embed,
    videoWrapper: elem,
    openDialog() {
      if (this.videoWrapper && this.embed) {
        const wrap = document.createElement('div');
        wrap.innerHTML = this.embed;
        const iframe = wrap.firstElementChild;
        if (iframe) {
          iframe.removeAttribute('width');
          iframe.removeAttribute('height');
          iframe.className = 'w-full h-full';
          const src = iframe.getAttribute('src') ?? '';
          iframe.setAttribute('src', `${src}${src.indexOf('?') > -1 ? '&' : '?'}autoplay=1&rel=0`);
          iframe.toggleAttribute('autoplay', true);

          this.videoWrapper.innerHTML = iframe.outerHTML;
        }

        this.open = true;
        document.body.style.overflowY = 'hidden';
      }
    },
    closeDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
      if (this.videoWrapper) {
        this.videoWrapper.innerHTML = '';
      }
    },
  };
}
